// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF

import { LabelPackageInfoMessage } from '@tls/sw91-communication/types/com.api_db_access';
import React, { useState } from 'react';
import styled from 'styled-components';
import DataDetailImage from './DataDetailImage';
import IconHide from 'components/treactui-template/icons/IconHide';
import { useTranslation } from 'react-i18next';
import { SegmentedControl } from '@tls/treact-ui';
import { IconPreview } from '@tls/treact-ui/icons';

interface Props {
  projectId?: string;
  labelPackage?: LabelPackageInfoMessage;
}
function DataDetail({ labelPackage, projectId }: Readonly<Props>) {
  const { t } = useTranslation();
  const [showMask, setShowMask] = useState<boolean>(false);

  return (
    <Root>
      <Header>
        <div className='font-size_m'>
          <ImageLabelContainer>{t('project.data.image')}</ImageLabelContainer>
          {labelPackage?.imageName}
        </div>
        <StyledSegmentedControl
          label={t('project.data.overlay')}
          asAtom
          data-testid='data-detail-overlay-segmented-control'
        >
          <SegmentedControl.SegmentedControlButton
            selected={showMask}
            icon={<IconPreview />}
            onClick={() => setShowMask(true)}
            data-testid='data-detail-overlay-show-mask-segmented-control-button'
          />
          <SegmentedControl.SegmentedControlButton
            selected={!showMask}
            icon={<IconHide />}
            onClick={() => setShowMask(false)}
            data-testid='data-detail-overlay-hide-mask-segmented-control-button'
          />
        </StyledSegmentedControl>
      </Header>
      <ImageContainer>
        <DataDetailImage
          projectId={projectId}
          imageId={labelPackage?.imageMd5}
          hasMask={labelPackage?.hasMask && showMask}
        />
      </ImageContainer>
    </Root>
  );
}

const StyledSegmentedControl = styled(SegmentedControl)`
  width: 10rem;
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  height: 100%;
`;
const Header = styled.div`
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
`;
const ImageContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
const ImageLabelContainer = styled.b`
  margin-right: 1rem;
`;
export default DataDetail;
